import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonContainerComponent } from './button-container.component';
import { BUTTON_CONTAINER_ALIGNMENT } from './button-container-alignment.enum';
import { BUTTON_CONTAINER_JUSTIFICATION } from './button-container-justification.enum';
import { BUTTON_CONTAINER_SPACING } from './button-container-spacing.enum';

const COMPONENTS = [ButtonContainerComponent];

@NgModule({
	imports: [CommonModule],
	exports: COMPONENTS,
	declarations: COMPONENTS
})
class EdAssistUIButtonContainerModule {}

export {
	EdAssistUIButtonContainerModule,
	ButtonContainerComponent,
	BUTTON_CONTAINER_ALIGNMENT,
	BUTTON_CONTAINER_JUSTIFICATION,
	BUTTON_CONTAINER_SPACING
};
